'use strict';

import { ElementOptionsAction } from '../../../../app/resources/element/element-options/element-options-action.interface';
import { ProjectElement } from '../../../../app/resources/element/project-element.interface';
import * as _ from 'lodash-es';
import { ProjectModule } from '../../../../app/resources/module/project-module.interface';
import { Subject } from 'rxjs';
import { skip, takeUntil } from 'rxjs/operators';

(function () {
  angular
    .module('specsguardApp')
    .controller('AreaDetailsCtrl', AreaDetailsCtrl);

  AreaDetailsCtrl.$inject = ['$scope', '$stateParams', 'project', 'Utils', 'Auth', 'Constants',
    'errorMessageService', 'projectLevel', '$location', 'ProjectDataservice', 'filterModuleFactory', 'Project',
    'ProjectBusinessService', 'Labels', '$mdDialog', 'sgAreaInheritanceHelpers', 'ProjectStateManagerService',
    'sg2ModalService', '$filter', 'sgElementHelpers'];

  function AreaDetailsCtrl ($scope, $stateParams, project, Utils, Auth, Constants,
    errorMessageService, projectLevel, $location, ProjectDataservice, filterModuleFactory, Project,
    ProjectBusinessService, Labels, $mdDialog, sgAreaInheritanceHelpers, ProjectStateManagerService,
    sg2ModalService, $filter, sgElementHelpers) {

    const ElementHelpers = new sgElementHelpers({ Constants });

    /* ========================================================================
     ==================================== model ================================
     ======================================================================== */

    const projectId = $stateParams.project_id;
    let buildingId;
    let building;
    let basicAreaId;
    let basicArea = {
      enabled: true,
      projectLevel,
    };
    let basicAreaAreas;
    let clusters;
    const areaId = $stateParams.area_id;

    $scope.updateProject = (proj, isInit) => {
      if (proj) {
        ProjectStateManagerService.project = proj;
      }

      setLocals(ProjectStateManagerService.project);
      setModel(ProjectStateManagerService.project);

      $scope.filterModules();
      if (!isInit) {
        ProjectDataservice.setProjectById(ProjectStateManagerService.project._id, ProjectStateManagerService.project);
      }
    };

    $scope.LABELS = Labels;

    $scope.config = {
      projectLevel,
      activeTab: 'area-general',
      backlink: {
        link: projectLevel === 5 ? '/project/' + projectId + '/building/' + $stateParams.building_id + '/areas' :
          '/project/' + projectId + '/basic-areas',
        text: projectLevel === 5 ? $scope.LABELS.getLabel('backtoarealist') : $scope.LABELS.getLabel('backtolibrary'),
        tooltip: projectLevel === 5 ? $scope.LABELS.getLabel('backtoarealist') : $scope.LABELS.getLabel('backtolibrary')
      }
    };

    const setLocals = (proj = project) => {
      if (projectLevel === 5) {
        setAreaLocals(proj);
      } else if (projectLevel === 4) {
        setBasicAreaLocals(proj);
      }
    };

    const setAreaLocals = (proj) => {
      buildingId = $stateParams.building_id;
      building = proj.buildings.find(function (bld) {
        return bld._id.toString() === buildingId.toString();
      });
    };

    const setBasicAreaLocals = (proj) => {
      basicAreaId = $stateParams.basic_area_id;
      basicArea = proj.basicAreas.find(function (bArea) {
        return bArea._id.toString() === basicAreaId.toString();
      });
      basicArea.projectLevel = 4;
      basicAreaAreas = [];
      clusters = [];

      proj.buildings.forEach(function (b) {
        b.clusters.forEach(function (cluster) {
          cluster.buildingId = b._id;
          cluster.buildingName = b.name;
          clusters.push(cluster);
          cluster.areas.forEach((area) => {
            const areaBasicArea = typeof area.basicArea === 'object' && area.basicArea.hasOwnProperty('_id')
              ? area.basicArea._id : area.basicArea;

            if (area.active && areaBasicArea === basicAreaId) {
              area.buildingId = b._id;
              area.buildingName = b.name;
              basicAreaAreas.push(area);
            }
          });
        });
      });
    };

    const setModel = (proj) => {
      const techModules = proj.modules.filter((module) => module.isTechnicalType);
      const menuModules = _.cloneDeep(techModules);
      const includeSet = $scope.model && angular.isDefined($scope.model.includeBasicAreaElements);

      $scope.model = {
        project: proj,
        building: building,
        qualityLevels: Constants.getList('QUALITY_LEVELS'),
        requirementTypes: Constants.getList('REQUIREMENT_TYPES'),
        clusters: building ? building.clusters : clusters,
        modules: techModules,
        activeModule: null,
        basicArea,
        basicAreaAreas,
        includeBasicAreaElements: true, // includeSet ? $scope.model.includeBasicAreaElements : !!basicArea.enabled,
        areaAmount: projectLevel === 4 ? basicAreaAreas.length : 0,
        menuStructure: filterModuleFactory.createMenuStructure(Constants.getList('REQUIREMENT_TYPES'), menuModules),
        canWrite: Utils.canWriteProject(Auth.getCurrentUser(), {
          accessLevel: null,
          projectLevels: ['manager', 'contributor'],
          project: proj,
        })
      };

      if (projectLevel === 5) {
        enrichAreaModel(proj);
      }
    };



    const enrichAreaModel = (proj) => {
      setBasicAreaForAreas(proj);
      findCluster();
      findArea();
    };

    const setBasicAreaForAreas = (proj) => {
      $scope.model.clusters.forEach((cluster) =>
        cluster.areas.forEach((area) => {
          if (typeof area.basicArea === 'string' || area.basicArea instanceof String) {
            area.basicArea = proj.basicAreas.find((basicA) => basicA._id === area.basicArea);
          }
        }));
    };

    const findCluster = () => {
      $scope.model.cluster = $scope.model.clusters.find((cluster) =>
        cluster.areas.find((area) => area._id === $stateParams.area_id));
    };

    const findArea = () => {
      $scope.model.area = $scope.model.cluster.areas.find(function (area) {
        return area._id === $stateParams.area_id;
      });
      if (!basicAreaId) {
        basicAreaId = $scope.model.area.basicArea && $scope.model.area.basicArea._id;
      }
      $scope.model.area.projectLevel = 5;
    };

    $scope.filterModules = (includeBasicAreaElements = $scope.model.includeBasicAreaElements) => {
      // the overview/general tab requires the menu structure as an extra layer
      if ($scope.config.activeTab === 'area-general') {
        $scope.model.filteredMenuStructure = $scope.model.menuStructure.map((menu) => {
          menu.modules = sgAreaInheritanceHelpers.
            overwriteBasicAreaElements(menu.modules, areaId, basicAreaId, Project);
          return menu;
        });
      } else if ($scope.config.viewtab !== 'basic-area-areas') {
        let mods = removeCircular($scope.model.modules);
        mods =  JSON.parse(JSON.stringify($scope.model.modules));
        mods = filterOnViewtab(mods);
        mods = sgAreaInheritanceHelpers.overwriteBasicAreaElements(mods, areaId, basicAreaId, project);
        mods = filterModuleFactory.addBasicAreaMarker(mods, areaId);
        mods = filterModuleFactory.filterBasicAreaElements(mods, includeBasicAreaElements);
        mods = filterModuleFactory.removeEmptySubmodules(mods);
        $scope.model.filteredModules = mods;
      }
    };

    /**
     * Remove properties that can cause a circular error.
     *
     * @note for some reason the `statusObj` property now also populates the `status` property (??),
     *  so make sure both `statusObj` is deleted, and *`status` is of type `number`*.
     *
     * @param modules List of project modules.
     * @returns Modules, with fix applied.
     */
    const removeCircular = (modules: ProjectModule[]): ProjectModule[] => {
      modules.forEach(module => {
        module.submodules.forEach(submodule => {
          submodule.elements.forEach(element => {
            // @ts-ignore
            element.status = typeof element.status === 'object'
              // @ts-ignore
              ? element.status._id
              : element.status;
            delete element.statusObj;
          });
        });
      });
      return modules;
    };

    const filterOnViewtab = (modules) =>
      modules.filter((mod) => {
        if ($scope.config.moduleId !== 'all' && mod._id !== $scope.config.moduleId) {
          return false;
        }
        return mod.active && $scope.config.activeTab === mod.viewtab;
      });

    $scope.updateProject(project, true);

    $scope.addElement = (ev) => {
      let module;
      if ($scope.config.moduleId !== 'all') {
        module = $scope.model.modules.find((mod) => mod._id === $scope.config.moduleId);
      } else if ($scope.config.activeTab) {
        module = $scope.model.modules.find((mod) => mod.viewtab === $scope.config.activeTab);
      }
      const submodule = module ? module.submodules[0] : null;
      const requirementType = $scope.model.requirementTypes.find((t) => t.value === $scope.config.activeTab);

      const action = 'create';
      const element = emptyElement({
        constructionId: $scope.model.area ? $scope.model.area._id : $scope.model.basicArea._id,
        projectLevel,
        quality: $scope.model.area ? $scope.model.area.basicArea.qualityLevel : $scope.model.basicArea.qualityLevel,
        requirementType: requirementType && requirementType._id,
        requirementStrictness: 2,
        inputType: $scope.config.activeTab === 'technisch' ? 'String' : 'Long String',
        moduleId: module ? module._id : null,
        module: module ? module : null,
        submoduleId: submodule ? submodule._id : null
      });

      let hiddenFields = ['projectLevel', 'appliesToFases', 'hasInputInstruction',
        'comment', 'constructionId', 'knowledgeLevel', 'requirementType'];
      if ($scope.config.activeTab !== 'technisch') {
        hiddenFields = [...hiddenFields, 'moduleId', 'submoduleId', 'inputType'];
      }

      $mdDialog.show({
        controller: 'SgElementDialogCtrl',
        controllerAs: '$SgElementDialogCtrl',
        locals: {
          title: Labels.getLabel('addtechnicalprojectspecification'),
          saveFunction: $scope[`${action}Element`],
          hideOverride: false,
          element,
          modules: $scope.model.modules.filter((m) => {
            // @ts-ignore
            if (!$scope.config.activeTab === 'all') {
              return true;
            }
            return m.viewtab === $scope.config.activeTab;
          }),
          constructions: $scope.model.area ? [$scope.model.area] : [$scope.model.basicArea],
          hiddenFields,
          projectLevel,
          appSection: 'project',
          action,
          constants: Constants.getAll(),
          showElementsNav: false,
          language: $scope.model.project.language,
        },
        bindToController: true,
        templateUrl: 'app-legacy/components/sg-element-dialog/sg-element-dialog.tmpl.html',
        targetEvent: ev,
        clickOutsideToClose: true,
      })
        // .then((proj) => {$scope.updateProject(proj, false)})
        .catch(() => {});
    };

    $scope.createElement = (element) => {
      const elementBody = ProjectBusinessService.getElementLocation($scope.model.project, element);
      elementBody.element = Object.assign(element, elementBody.element);
      elementBody.element.value = elementBody.element.values[0].value;

      return Project.addElement(elementBody).$promise
        .then((res) => {
          // Seeing as the API doesn't return the full object, let's update the existing object with the new data
          const updatedElement = {...elementBody.element, ...res.element};

          // Code missing? Create new one
          if (!updatedElement.code) {
            updatedElement.code = ProjectStateManagerService.project.key + '-' + updatedElement.identifier;
          }

          // Endpoint doesn't return fresh log, we can create one here
          if (!updatedElement.logs) {
            updatedElement.logs = [{type: 'CREATED', date: null, text: 'Project element created', userId: Auth.getCurrentUser()}];
          }

          // Vrij dubbel, maar dit is schijnbaar nodig
          if (!updatedElement.elementId) {
            updatedElement.elementId = updatedElement._id;
          }

          // Geen idee waar dit vandaan komt, maar het moet weg
          delete updatedElement.module;
          delete updatedElement.submodule;
          ProjectStateManagerService.appendElement(updatedElement);


          $scope.updateProject(ProjectStateManagerService.project, false);
          return Promise.resolve({
            message: Labels.getLabel('addedspecification'),
            project: ProjectStateManagerService.project,
            element: res.element,
          });
        });
    };

    /* ========================================================================
    =============================== methods ===================================
    ======================================================================== */

    /**
     * On new element options action.
     *
     * An element options action is dispatched after using the
     * <sg2-element-options> compononent.
     */
    $scope.$on('sg2ElementOptionsAction', (event: Event, action: ElementOptionsAction) => {
      switch (action.action) {
        case 'assignTo':
          assignElementTo(action);
          break;
        case 'delete':
          deleteElementConfirm(action);
          break;
        case 'edit':
          editElementModal(action);
          break;
        case 'restore':
          resetElement(action);
          break;
        case 'setStatus':
          setStatus(action);
          break;
      }
    });

    /**
     * Assign an element to a user.
     *
     * @param action The dispatched action from the options menu.
     */
    const assignElementTo = (action: ElementOptionsAction): void => {
      action.element[action.key] = action.value;

      const elementLocation = ProjectBusinessService.getElementLocation(ProjectStateManagerService.project, action.element);
      elementLocation.element = Object.assign(elementLocation.element, action.element);

      Project.patchElement(elementLocation).$promise.then(response => {
        errorMessageService.showSuccess($scope.LABELS.getLabel('specificationedited'));
        ProjectStateManagerService.updateElement(action.element._id, action.element);
        $scope.updateProject(ProjectStateManagerService.project, true);
      });
    };

    /**
     * Delete element confirmation modal.
     *
     * @todo Doesn't seem to work anymore, make ticket.
     *
     * @param element Element to delete.
     */
    const deleteElementConfirm = (action: ElementOptionsAction): void => {
      const deleteModal = sg2ModalService.confirm({
        title: Labels.getLabel('deletespecificationtitle'),
        content: Labels.getLabel('areyousuredeletespecification'),
        action: Labels.getPlural('delete'),
        actionIcon: 'delete',
        type: 'warn'
      });
      deleteModal.afterClosed().subscribe((click: any) => {
        if (click === 'confirm') {
          deleteElement(action.element);
        }
      });
    };

    /**
     * Delete element.
     *
     * @param element Element to delete.
     */
    const deleteElement = (element: ProjectElement): void => {
      element.active = false;
      element.isCustom = false;

      ProjectStateManagerService.deleteElement(element);
      const elementLocation = ProjectBusinessService.getElementLocation(ProjectStateManagerService.project, element);
      elementLocation.element = Object.assign(elementLocation.element, element);
      $scope.updateProject(ProjectStateManagerService.project, true);

      Project.patchElement(elementLocation).$promise.then(response => {
        errorMessageService.showSuccess($scope.LABELS.getLabel('deletedspecification'));
      });
    };

    /**
     * Edit element modal.
     *
     * @param action The dispatched action from the options menu.
     */
    const editElementModal = (action: ElementOptionsAction): void => {
      const element = action.element;
      const hiddenFields = ['projectLevel', 'appliesToFases', 'hasInputInstruction',
        'comment', 'constructionId', 'knowledgeLevel', 'requirementType', 'moduleId', 'submoduleId'];

      $mdDialog.show({
        controller: 'SgElementDialogCtrl',
        controllerAs: '$SgElementDialogCtrl',
        scope: $scope.$new(),
        locals: {
          action: 'edit',
          title: Labels.getLabel('edit'),
          saveFunction: editElement,
          hideOverride: false,
          element: angular.copy(element),
          modules: $scope.model.modules.filter((m) => {
            return $scope.config.activeTab === 'all'
              ? m.viewtab === $scope.config.activeTab
              : true;
          }),
          constructions: $scope.model.area
            ? [$scope.model.area]
            : [$scope.model.basicArea],
          projectLevel: 0,
          appSection: 'project',
          language: $scope.model.project.language,
          constants: Constants.getAll(),
          showElementsNav: false,
          hiddenFields
        },
        bindToController: true,
        templateUrl: 'app-legacy/components/sg-element-dialog/sg-element-dialog.tmpl.html',
        clickOutsideToClose: true,
      });
    };

    /**
     * Edit element.
     *
     * @param action The dispatched action from the options menu.
     */
    const editElement = (res) => {

      // Prevent circular reference
      delete res.statusObj;
      delete res.action;

      const updatedElement = Object.assign({}, res);
      if (angular.isDefined(updatedElement.qualityLevel)) {
        updatedElement.value = ElementHelpers.getElementValue(updatedElement);
        // updatedElement.templateValues = updatedElement.values; // ??
      }
      updatedElement.updated = new Date().toString();
      updatedElement.readableupdatedDate = $filter('sgDateAgo')(new Date());

      return new Promise(resolve => {
        const elementLocation = ProjectBusinessService.getElementLocation(ProjectStateManagerService.project, updatedElement);
        elementLocation.element = Object.assign(elementLocation.element, updatedElement);

        Project.patchElement(elementLocation).$promise.then(response => {
          ProjectStateManagerService.updateElement(updatedElement._id, updatedElement);
          errorMessageService.showSuccess($scope.LABELS.getLabel('specificationedited'));
          $scope.updateProject(ProjectStateManagerService.project, true);

          resolve(true);
        });
      });
    };

    /**
     * Reset element to original template value.
     *
     * @param action The dispatched action from the options menu.
     */
    const resetElement = (action: ElementOptionsAction): void => {
      const element = action.element;
      element.active = false;

      ProjectStateManagerService.deleteElement(element);
      const elementLocation = ProjectBusinessService.getElementLocation(ProjectStateManagerService.project, element);
      elementLocation.element = Object.assign(elementLocation.element, element);

      Project.patchElement(elementLocation).$promise.then(response => {

        // Get project from API. To make sure you get the latest, clear project cache first.
        ProjectDataservice.resetProjectById($scope.model.project._id);
        ProjectDataservice.getProjectById($scope.model.project._id).then(pr => {
          errorMessageService.showSuccess($scope.LABELS.getLabel('restoredareatemplate'));
          ProjectStateManagerService.project = pr;
          $scope.updateProject(ProjectStateManagerService.project, true);
        });
      });
    };

    /**
     * Set element status.
     *
     * @param action The dispatched action from the options menu.
     */
    const setStatus = (action: ElementOptionsAction): void => {
      action.element[action.key] = action.value;

      const elementLocation = ProjectBusinessService.getElementLocation(ProjectStateManagerService.project, action.element);
      elementLocation.element = Object.assign(elementLocation.element, action.element);

      Project.patchElement(elementLocation).$promise.then(response => {
        errorMessageService.showSuccess($scope.LABELS.getLabel('specificationedited'));
        ProjectStateManagerService.updateElement(action.element._id, action.element);
        $scope.updateProject(ProjectStateManagerService.project, true);
      });
    };

    /**
     * After updating an element using sg-inline, push this update to the current project state,
     * and trigger a 'projectUpdate' so the change is visible after using the toggle.
     */
    $scope.$on('element:update:inline', (event: Event, element: ProjectElement) => {
      setTimeout(() => {
        ProjectStateManagerService.updateElement(element._id, element);
        $scope.updateProject(ProjectStateManagerService.project, true);
      }, 250);
    });

    $scope.switchView = function (viewtab, moduleId, module) {
      $scope.config.activeTab = viewtab;
      $scope.config.moduleId = moduleId;
      $scope.config.activeSubTab = (moduleId === 'all') ? '' : moduleId;
      $scope.filterModules();
    };

    $scope.goArea = (area) => $location.path(`/project/${project._id}/building/${area.buildingId}/areas/${area._id}`);

    function emptyElement (extension) {
      const defaultTechElement = {
        hasInputInstruction: false,
        hasMultipleQualityLevels: false,
        isPresentInPvEDocument: false,
        knowledgeLevel: 3,
        appliesToFases: [1, 2, 3, 4],
        templateValues: [],
        isCustom: true,
        isTechnicalType: true,
        active: true,
      };

      return Object.assign({}, defaultTechElement, extension);
    }
  }

})();
